import React from "react"
import Tooltip from "rc-tooltip"

const serializers = {
  marks: {
    tooltip: ({ mark, children }) => {
      if (!mark || !children) {
        return "Missing tooltip description!"
      }
      return (
        <Tooltip
          trigger={["hover", "click", "focus"]}
          placement="top"
          mouseLeaveDelay={0}
          defaultVisible={false}
          overlay={mark.description}
          destroyTooltipOnHide={true}
          overlayClassName="relative inline-block px-4 py-1 bg-primary text-white rounded-lg shadow-md tooltip-arrow"
        >
          <span
            className="tooltip-term border-b-2 border-dotted border-current cursor-pointer"
            tabIndex={0}
            role="button"
          >
            {children[0]}
          </span>
        </Tooltip>
      )
    },
  },
}

export { serializers }
